import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.shades['clr-white-900'],
  },
  [`& .${tooltipClasses.tooltip}`]: {
    minWidth: 'fit-content',
    padding: '14px',
    borderRadius: '8px',
    backgroundColor: theme.palette.shades['clr-white-900'],
    boxShadow: "0px 0px 23px 0px #1961BF80"
  },
}));

export default function NewTooltip({ component = '', children, placement = 'top', ...props  }) {
  return (
    <BootstrapTooltip title={component} placement={placement} {...props}>
      {children}
    </BootstrapTooltip>
  );
}